<template>
    <div>
        <!-- <template hidden>
            <download-excel id="button_export_excel"
                v-show="false"
                :name="data.filename+'.xls'"
                :data="data.json_data"
                :fields="json_fields"
            >
            </download-excel>
        </template> -->
        <!-- <template hidden>
            <download-csv id="button_export_csv"
                v-show="false"
                :data="data.rows"
                :labels="json_fields"
                :name="data.filename+'.csv'"
                :fields="array_fields"
                
                >
            </download-csv>
        </template> -->
    </div>
</template>
<script>
import Vue from 'vue'
import { requestService } from '../../_services';
// import JsonExcel from "vue-json-excel"; 
// import JsonCSV from 'vue-json-csv'
// Vue.component("downloadExcel", JsonExcel);
// Vue.component('downloadCsv', JsonCSV)
export default {
    name: 'ExportData', // `name` is required as a recursive component
    components: { 
    },
    props: {
        data: Object,
    },
    data() {
        return {
            // json_fields:{},
            // array_fields:[],
            // json_meta: [
            //     [
            //         {
            //             key: "charset",
            //             value: "utf-8",
            //         },
            //     ],
            // ],
        };
    },
    async mounted() {
        
    },
    methods: {
        async exportItem(){
            return requestService.GetFetch(this.data.module,this.data.exportUrl).then((response) => {
                if (response.status == 200) {
                    response.text().then((text) => {
                        let self = this;
                        var csvString = text;
                        var universalBOM = "\uFEFF";
                        var a = window.document.createElement('a');
                        a.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM+csvString));
                        a.setAttribute('download', this.data.exportFileName);
                        window.document.body.appendChild(a);
                        a.click();
                    });
                }
            }); 
            // const res = await requestService.GetFetch(this.data.exportUrl);
            // console.log("res",res);
            // const blob = await res.blob();
            // const url = window.URL.createObjectURL(blob);
            // var a = document.createElement("a");
            // document.body.appendChild(a);
            // a.style = "display: none";
            // // url = window.URL.createObjectURL(blob);
            // a.href = url;
            // a.download = this.data.exportFileName;
            // a.click();
            // window.URL.revokeObjectURL(url);
            // a.remove();
        },
        // async exportXlsxData(){
        //     await this.loadFromXlsx()
        //     await document.getElementById("button_export_excel").click();
        // },
        // async exportCsvData(){
        //     await this.loadFromCsv()
        //     await document.getElementById("button_export_csv").click();
        // },
        // async loadFromXlsx(){
        //     this.json_fields={}
        //     this.data.columns.forEach(item => {
        //         if(!item.hidden){
        //             if(item.topic !="Default"){
        //                 this.json_fields[item.label]="data."+item.topic+"."+item.field
        //                 this.array_fields.push(item.label);
        //             }else{
        //                 this.json_fields[item.label]=item.field
        //                 this.array_fields.push(item.label);
        //             }
        //         }     
        //     });
        // },
        // async loadFromCsv(){
        //     this.json_fields={}
        //     this.array_fields=[]
        //     this.data.columns.forEach(item => {
        //         if(!item.hidden){
        //             this.json_fields[item.field]=item.label
        //             this.array_fields.push(item.field);
        //         }     
        //     });
        // },
        
    }
};
</script>